import React from "react";
import Header8 from "./../Common/Header8";
import Footer from "./../Common/Footer";
import Banner from "./../Elements/Banner";

const blogs = [
  {
    image: require("./../../images/blog/event_2.jpg"),
    title: "COMMUNIQUE Projet Vallée Val d’OR II",
    date: "31",
    month: "DEC",
    year: "2020",
  },
  {
    image: require("../../images/annonces/image1.jpg"),
    title: "COMMUNIQUE Projet Vallée Val d’OR I",
    date: "25",
    month: "SEP",
    year: "2022",
  },
];

var bnrimg = require("../../images/banner/banner.jpg")


class BlogGrid extends React.Component {
  render() {
    return (
      <>
        <Header8 />
        <div className="page-content">
          <Banner title="Actualités" pagename="Actualités" bgimage={bnrimg} />

          <div className="section-full p-tb80 bg-white inner-page-padding">
            <div className="container">
              <div className="masonry-outer mfp-gallery news-grid clearfix row ">
                {blogs.map((item, index) => (
                  <div
                    className="masonry-item  col-lg-6 col-md-6 col-sm-12"
                    key={index}
                    data-aos-duration="800"  data-aos="zoom-in-down"
                  >
                    <div className="blog-post blog-grid date-style-2">
                      <div className="sx-post-media sx-img-effect img-reflection">
                        <a href={"/annonces/valle-val-or-1"}>
                          <img src={item.image} alt="" />
                        </a>
                      </div>
                      <div className="sx-post-info p-t30">
                        <div className="sx-post-meta ">
                          <ul>
                            <li className="post-date">
                              <strong>{item.date}</strong>{" "}
                              <span>{item.month}</span> <span>{item.year}</span>{" "}
                            </li>
                          </ul>
                        </div>
                        <div className="sx-post-title ">
                          <h4 className="post-title">
                            <a href={"/annonces/valle-val-or-1"}>{item.title}</a>
                          </h4>
                          <p className="">
                            Dans le cadre du renforcement de ses actions de
                            communication, le bureau de l’Association la vallée
                            a le plaisir d’informer ses adhérents et membres
                            bénéficiaires du programme...
                          </p>
                        </div>
                        <div className="sx-post-readmore">
                          <a
                            href={"/annonces/valle-val-or-1"}
                            title="Voir Plus"
                            rel="bookmark"
                            className="site-button-link"
                          >
                            Voir Plus
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <ul className="pagination m-t30 m-b0">
                <li>
                  <a href={"#"}>«</a>
                </li>
                <li className="active">
                  <a href={"#"}>1</a>
                </li>
                <li>
                  <a href={"#"}>2</a>
                </li>
                <li>
                  <a href={"#"}>3</a>
                </li>
                <li>
                  <a href={"#"}>4</a>
                </li>
                <li>
                  <a href={"#"}>5</a>
                </li>
                <li>
                  <a href={"#"}>»</a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <Footer />
      </>
    );
  }
}

export default BlogGrid;
